import { isLargeMediumViewPort } from "../search/domains/ui/helpers/viewportHelper";

export const COMMIT_POLICY = {
  NOW: "now",
  DEBOUNCE: "debounce",
  DEFER: "defer",
};

export const EDIT_SOURCE = {
  VALUE_IN_PANEL: "valueInPanel",
  ACTION_IN_PANEL: "actionInPanel",
  OUTSIDE_PANEL: "outsidePanel",
  ALWAYS_COMMITS: "alwaysCommits",
  NEVER_COMMITS: "neverCommits",
};

const { NOW, DEBOUNCE, DEFER } = COMMIT_POLICY;

const POLICY_TABLE = {
  [EDIT_SOURCE.VALUE_IN_PANEL]: { largeMedium: DEBOUNCE, small: DEFER },
  [EDIT_SOURCE.ACTION_IN_PANEL]: { largeMedium: NOW, small: DEFER },
  [EDIT_SOURCE.OUTSIDE_PANEL]: { largeMedium: NOW, small: NOW },
  [EDIT_SOURCE.ALWAYS_COMMITS]: { largeMedium: NOW, small: NOW },
  [EDIT_SOURCE.NEVER_COMMITS]: { largeMedium: DEFER, small: DEFER },
};

export const resolveCommitPolicy = (source, state) => {
  const row = POLICY_TABLE[source] || POLICY_TABLE[EDIT_SOURCE.NEVER_COMMITS];

  return isLargeMediumViewPort(state) ? row.largeMedium : row.small;
};

export const commitWillFollow = (policy) => policy !== COMMIT_POLICY.DEFER;

// Value changes are reported with the eventual search even when Done commits them.
export const willSearchFollow = (source, state) =>
  source === EDIT_SOURCE.VALUE_IN_PANEL ||
  commitWillFollow(resolveCommitPolicy(source, state));
